import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  names: {}
}))

export default useStyles
